"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValueDifference_1 = require("../../core/model/ValueDifference");

var ForecastChangeProductDTO_1 = require("../model/ForecastChangeProductDTO");

var ProductChangeType_1 = require("../model/ProductChangeType");

var ForecastChangeProductDTOConverter_1 = require("./ForecastChangeProductDTOConverter");

var ForecastChangeSupplierAgreementDTOConverter_1 = require("./ForecastChangeSupplierAgreementDTOConverter");
/**
 * @author Adam Drda
 */


var ForecastChangeProductDTOConverterImpl =
/*#__PURE__*/
function (_ForecastChangeProduc) {
  _inherits(ForecastChangeProductDTOConverterImpl, _ForecastChangeProduc);

  function ForecastChangeProductDTOConverterImpl(forecastChangeSupplierAgreementDTOConverter) {
    var _this;

    _classCallCheck(this, ForecastChangeProductDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeProductDTOConverterImpl).call(this));
    _this.forecastChangeSupplierAgreementDTOConverter = forecastChangeSupplierAgreementDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastChangeProductDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ForecastChangeProductDTO_1.ForecastChangeProductDTO(ForecastChangeProductDTO_1.ForecastChangeProductDTO.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ForecastChangeProductDTO_1.ForecastChangeProductDTO.schema.changeType.valueOf(conversions.asEnum(source.changeType, ProductChangeType_1.ProductChangeType)), conversions.asObject(source, 'promoVolume', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)), conversions.asObject(source, 'systemVolume', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)), conversions.asObject(source, 'promoPrice', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)), conversions.asObject(source, 'groupOfSitesId', ValueDifference_1.deserializeValueDifferenceString()), conversions.asObjectList(source, 'supplierAgreements', function (doc) {
        return _this2.forecastChangeSupplierAgreementDTOConverter.toObject(doc, conversions);
      }), conversions.asObject(source, 'vendorAllowance', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)), conversions.asObject(source, 'windowChanged', ValueDifference_1.deserializeValueDifferenceMoment(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      return {
        productId: conversions.toDocumentReferenceId(source.productId),
        changeType: source.changeType,
        promoVolume: conversions.asObject(source, 'promoVolume', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        systemVolume: conversions.asObject(source, 'systemVolume', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        promoPrice: conversions.asObject(source, 'promoPrice', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        groupOfSitesId: conversions.asObject(source, 'groupOfSitesId', ValueDifference_1.serializeValueDifferenceString()),
        supplierAgreements: conversions.asObjectArray(source, 'supplierAgreements', function (doc) {
          return _this3.forecastChangeSupplierAgreementDTOConverter.toDocument(doc, conversions);
        }),
        vendorAllowance: conversions.asObject(source, 'vendorAllowance', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        windowChanged: conversions.asObject(source, 'windowChanged', ValueDifference_1.serializeValueDifferenceMoment(conversions))
      };
    }
  }]);

  return ForecastChangeProductDTOConverterImpl;
}(ForecastChangeProductDTOConverter_1.ForecastChangeProductDTOConverter);

ForecastChangeProductDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ForecastChangeSupplierAgreementDTOConverter_1.ForecastChangeSupplierAgreementDTOConverter])], ForecastChangeProductDTOConverterImpl);
exports.ForecastChangeProductDTOConverterImpl = ForecastChangeProductDTOConverterImpl;